import "./Hero.css";

import { Link } from "react-router-dom";

import {
  FaArrowRight,
  FaBath,
  FaBed,
  FaCalendarAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

import edificio from "../assets/proyecto1.jpg";
import tipoA from "../assets/proyecto7.jpg";
import tipoB from "../assets/proyecto3.jpg";
import tipoC from "../assets/proyecto5.jpg";

const apartamentos = [
  {
    id: 1,
    nombre: "Tipo A",
    area: "144.79 m²",
    precio: "US$194,308.18",
    habitaciones: "3",
    baños: "4",
    imagen: tipoA,
    ruta: "/apartamentos/tipo-a",
  },
  {
    id: 2,
    nombre: "Tipo B",
    area: "129.67 m²",
    precio: "US$174,017.14",
    habitaciones: "3",
    baños: "2.5",
    imagen: tipoB,
    ruta: "/apartamentos/tipo-b",
  },
  {
    id: 3,
    nombre: "Tipo C",
    area: "86.47 m²",
    precio: "US$130,000",
    habitaciones: "2",
    baños: "2.5",
    imagen: tipoC,
    ruta: "/apartamentos/tipo-c",
  },
];

function Hero() {
  return (
    <section className="hero" id="inicio">
      <div className="hero-decoration hero-decoration-one"></div>
      <div className="hero-decoration hero-decoration-two"></div>

      <div className="hero-container">
        {/* CONTENIDO IZQUIERDO */}

        <div className="hero-content">
          <div className="hero-kicker">
            <span></span>
            Proyecto residencial exclusivo
          </div>

          <h1>
            Un hogar diseñado para vivir mejor
          </h1>

          <p className="hero-description">
            Arquitectura contemporánea, espacios funcionales y
            terminaciones cuidadosamente seleccionadas en una
            ubicación estratégica de San Cristóbal.
          </p>

          <div className="hero-location">
            <div className="hero-location-icon">
              <FaMapMarkerAlt />
            </div>

            <div>
              <span>Ubicación del proyecto</span>

              <strong>
                Madre Vieja Sur, San Cristóbal
              </strong>
            </div>
          </div>

          <div className="hero-actions">
            <a
              href="#apartamentos"
              className="hero-primary-button"
            >
              Ver apartamentos
              <FaArrowRight />
            </a>

            <Link
              to="/reserva"
              className="hero-secondary-button"
            >
              <FaCalendarAlt />
              Agendar visita
            </Link>
          </div>

          {/* APARTAMENTOS PEQUEÑOS */}

          <div className="hero-apartments">
            {apartamentos.map((apartamento) => (
              <Link
                to={apartamento.ruta}
                className="hero-apartment"
                key={apartamento.id}
                aria-label={`Ver detalles del Apartamento ${apartamento.nombre}`}
              >
                <div className="hero-apartment-image">
                  <img
                    src={apartamento.imagen}
                    alt={`Apartamento ${apartamento.nombre}`}
                  />

                  <span className="hero-apartment-status">
                    Disponible
                  </span>
                </div>

                <div className="hero-apartment-information">
                  <div className="hero-apartment-heading">
                    <strong>{apartamento.nombre}</strong>
                    <span>{apartamento.area}</span>
                  </div>

                  <div className="hero-apartment-specifications">
                    <span>
                      <FaBed />
                      {apartamento.habitaciones} hab.
                    </span>

                    <span>
                      <FaBath />
                      {apartamento.baños} baños
                    </span>
                  </div>

                  <small>{apartamento.precio}</small>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* FACHADA DERECHA */}

        <div className="hero-visual">
          <div className="hero-visual-frame"></div>

          <div className="hero-image-frame">
            <img
              src={edificio}
              alt="Fachada de Residencial YANNA I"
              className="hero-main-image"
            />

            <div className="hero-image-light"></div>
          </div>

          <div className="hero-project-name">
            <span>Residencial</span>
            <strong>YANNA I</strong>
          </div>

          <div className="hero-floating-card">
            <span>Precio inicial</span>
            <strong>US$130,000</strong>
            <small>Unidades disponibles</small>
          </div>

          <div className="hero-availability-card">
            <span></span>

            <div>
              <small>ESTADO DEL PROYECTO</small>
              <strong>Unidades disponibles</strong>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;